import { render, staticRenderFns } from "./orderTags.vue?vue&type=template&id=0f29d458&scoped=true"
import script from "./orderTags.vue?vue&type=script&lang=js"
export * from "./orderTags.vue?vue&type=script&lang=js"
import style0 from "./orderTags.vue?vue&type=style&index=0&id=0f29d458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f29d458",
  null
  
)

export default component.exports